<template lang="html">
  <div class="">
    <!-- Суперадмин не должен видеть эту страницу, редирект обрабатывается в App.vue -->
    <Objects v-if="$store.state.user.customer && $store.state.user.customer.manager && !$store.state.user.is_superuser"/>
    <Devices v-else-if="$store.state.user.id && !$store.state.user.is_superuser"/>
    <div v-else-if="$store.state.user.is_superuser" class="p-4">
      <p>Выберите раздел в меню управления</p>
    </div>
  </div>
</template>

<script>
import Objects from './Objects'
import Devices from './Devices'
import {router} from '../main'

export default {
  components: {
    Objects,
    Devices
  },
  mounted () {
    // Редирект суперадмина на страницу управления группами
    if (this.$store.state.user.is_superuser) {
      router.push('/manage/groups')
    }
  }
}
</script>


<style lang="css" scoped>
</style>
